import { render, staticRenderFns } from "./MeasuresView.vue?vue&type=template&id=71c69e77&"
import script from "./MeasuresView.vue?vue&type=script&lang=ts&"
export * from "./MeasuresView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports